<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="title">Title</label>
                    <input id="title" type="text" class="form-control" [(ngModel)]="target.title" name="title" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="body">Popup Body</label>
                    <input id="body" type="text" class="form-control" [(ngModel)]="target.body" name="body" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="recipients">Recipient Groups</label>
                    <wj-multi-select
                        name="recipients"
                        [showSelectAllCheckbox]="true"
                        [showFilterInput]="true"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [itemsSource]="recipientsMap"
                    >
                    </wj-multi-select>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group">
                    <label for="scheduledDate">Scheduled (optional)</label>
                    <wj-input-date-time
                        id="scheduledDate"
                        [isRequired]="false"
                        [timeStep]="30"
                        [(ngModel)]="target.scheduledDate"
                        name="scheduledDate"
                    ></wj-input-date-time>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="expiresOn">Expires On</label>
                    <wj-input-date
                        id="expiresOn"
                        [(ngModel)]="target.expiresOn"
                        name="expiresOn"
                    ></wj-input-date>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="richBody">Body</label>
                    <quill-editor
                        #quillEditorRef
                        style="width: 100%"
                        [(ngModel)]="target.richBody"
                        name="richBody"
                        [styles]="{ height: '200px' }"
                        [modules]="editorModules"
                    >
                    </quill-editor>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="notes">Notes</label>
                    <textarea id="notes" rows="2" class="form-control" [(ngModel)]="target.notes" name="notes"></textarea>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
